import { toast } from "sonner";

/**
 * Profesyonel Toast Bildirimleri
 * 
 * Her toast türü için özelleştirilmiş mesajlar ve ikonlar
 */

export const showToast = {
  // ✅ Başarı mesajları
  success: (message, description = null) => {
    toast.success(message, {
      description,
      icon: '✅',
      duration: 2000,
      position: 'top-right',
    });
  },

  // ❌ Hata mesajları
  error: (message, description = null) => {
    toast.error(message, {
      description,
      icon: '❌',
      duration: 5000,
      style: {
        background: '#ef4444',
        color: 'white',
        border: '1px solid #dc2626',
      },
    });
  },

  // ⚠️ Uyarı mesajları
  warning: (message, description = null) => {
    toast.warning(message, {
      description,
      icon: '⚠️',
      duration: 4000,
      style: {
        background: '#f59e0b',
        color: 'white',
        border: '1px solid #d97706',
      },
    });
  },

  // ℹ️ Bilgi mesajları
  info: (message, description = null) => {
    toast.info(message, {
      description,
      icon: 'ℹ️',
      duration: 3000,
      style: {
        background: '#3b82f6',
        color: 'white',
        border: '1px solid #2563eb',
      },
    });
  },

  // 🎉 Kutlama mesajları
  celebration: (message, description = null) => {
    toast.success(message, {
      description,
      icon: '🎉',
      duration: 4000,
      style: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        border: '1px solid #5a67d8',
      },
    });
  },

  // 🔐 Güvenlik/Auth mesajları
  auth: (message, description = null) => {
    toast.success(message, {
      description,
      icon: '🔐',
      duration: 3000,
      style: {
        background: '#8b5cf6',
        color: 'white',
        border: '1px solid #7c3aed',
      },
    });
  },

  // 💾 Kaydetme mesajları
  saved: (message, description = null) => {
    toast.success(message, {
      description,
      icon: '💾',
      duration: 2500,
      style: {
        background: '#06b6d4',
        color: 'white',
        border: '1px solid #0891b2',
      },
    });
  },

  // 🗑️ Silme mesajları
  deleted: (message, description = null) => {
    toast.success(message, {
      description,
      icon: '🗑️',
      duration: 1500,
      position: 'top-right',
    });
  },

  // ⏳ Yükleniyor mesajları (promise için)
  loading: (message) => {
    return toast.loading(message, {
      icon: '⏳',
      style: {
        background: '#6366f1',
        color: 'white',
        border: '1px solid #4f46e5',
      },
    });
  },

  // Promise-based toast (loading → success/error)
  promise: (promise, messages) => {
    return toast.promise(promise, {
      loading: {
        title: messages.loading || 'İşlem yapılıyor...',
        icon: '⏳',
      },
      success: (data) => ({
        title: messages.success || 'Başarılı!',
        description: data?.message,
        icon: '✅',
      }),
      error: (err) => ({
        title: messages.error || 'Hata oluştu',
        description: err?.response?.data?.detail || err?.message,
        icon: '❌',
      }),
    });
  },
};

// Özel durum mesajları
export const customToasts = {
  adminCreated: (name) => showToast.celebration('Admin Eklendi!', `${name} başarıyla sisteme eklendi.`),
  adminDeleted: (name) => showToast.deleted('Admin Silindi', `${name} sistemden kaldırıldı.`),
  adminUpdated: (name) => showToast.saved('Admin Güncellendi', `${name} bilgileri güncellendi.`),
  
  passwordReset: () => showToast.auth('Şifre Güncellendi', 'Yeni şifre başarıyla kaydedildi.'),
  
  kidLinked: (kidName, parentName) => showToast.celebration('Kids Bağlandı!', `${kidName}, ${parentName} ebeveynine bağlandı.`),
  
  profileUpdated: () => showToast.saved('Profil Güncellendi', 'Değişiklikler başarıyla kaydedildi.'),
  
  loginSuccess: (name) => showToast.auth('Hoş Geldiniz!', `${name}, panele giriş yaptınız.`),
  
  unauthorized: () => showToast.error('Yetki Hatası', 'Bu işlem için yetkiniz yok.'),
  
  networkError: () => showToast.error('Bağlantı Hatası', 'Sunucuya ulaşılamıyor. Lütfen tekrar deneyin.'),
};

export default showToast;
